import React from 'react';
import { Button, Space, Typography } from 'antd';
import { HomeOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

interface PageNavigationProps {
    title?: string;
    showHomeButton?: boolean;
    showBackButton?: boolean;
    customBackAction?: () => void;
    style?: React.CSSProperties;
}

const PageNavigation: React.FC<PageNavigationProps> = ({
    title,
    showHomeButton = true,
    showBackButton = true,
    customBackAction,
    style
}) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleBack = () => {
        if (customBackAction) {
            customBackAction();
        } else {
            navigate(-1); // Go back to previous page
        }
    };

    const handleHome = () => {
        navigate('/dashboard');
    };

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '24px',
                padding: '16px 24px',
                background: '#f5f5f5',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                ...style
            }}
        >
            <div>
                {title && (
                    <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                        {title}
                    </Title>
                )}
            </div>

            <Space>
                {showBackButton && (
                    <Button
                        type="default"
                        icon={<ArrowLeftOutlined />}
                        onClick={handleBack}
                        size="large"
                        style={{
                            borderRadius: '8px',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
                        }}
                    >
                        {t('go_back')}
                    </Button>
                )}

                {showHomeButton && (
                    <Button
                        type="primary"
                        icon={<HomeOutlined />}
                        onClick={handleHome}
                        size="large"
                        style={{
                            borderRadius: '8px',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
                        }}
                    >
                        {t('go_home')}
                    </Button>
                )}
            </Space>
        </div>
    );
};

export default PageNavigation;
